// ABOUTME: Helper to pick the least-far tracking status across an order's shipments.
// ABOUTME: Problem statuses rank before the normal progression so failures stay visible.

// Lower rank = less far along. Problem statuses rank below the normal
// created -> underway -> delivered progression so an order with a failed
// shipment surfaces the failure even when a sibling shipment is delivered.
// Unrecognized statuses rank lowest of all so new backend values surface too.
const SHIPMENT_STATUS_RANK = {
    not_delivered: 1,
    failed: 1,
    not_fetched: 1,
    created: 2,
    underway: 3,
    delivered: 4,
};

export const getLeastFarShipmentStatus = (shipments) => {
    const statuses = (shipments ?? [])
        .map((shipment) => shipment?.shipmentStatus)
        .filter(Boolean);

    if (statuses.length === 0) return null;

    return statuses.reduce((leastFar, status) => {
        const leastFarRank = SHIPMENT_STATUS_RANK[leastFar] ?? 0;
        const rank = SHIPMENT_STATUS_RANK[status] ?? 0;
        return rank < leastFarRank ? status : leastFar;
    });
};
